export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-13.2f292ced.png";